import { AnyAction } from 'redux'
import { produce } from 'immer'
import { PaginateRequest, PaginateResponse } from '../../services/api.service'
import { PalletData } from '../../apis/pallet.api'
import palletService from '../../services/pallet.service'
import { ActionName } from '../../components/Actions'

interface State extends PaginateRequest {
  result: PaginateResponse<PalletData[]>
  search: string
  startAt: string
  endAt: string
}

const initialState: State = {
  result: {
    data: [],
    total: 0,
    from: null,
    to: null,
    currentPage: 0,
    lastPage: 0
  },
  page: 1,
  limit: 25,
  search: '',
  startAt: '',
  endAt: ''
}

export const actions = {
  replaceResult: 'barePallets/replaceResult',
  replaceResultData: 'barePallets/replaceResultData',
  replacePage: 'barePallets/replacePage',
  replaceLimit: 'barePallets/replaceLimit',
  replaceSearch: 'barePallets/replaceSearch',
  replaceFilter: 'barePallets/replaceFilter'
}

export function replaceResult (result: State['result']) {
  return { type: actions.replaceResult, result }
}

export function replaceResultData (data: State['result']['data']) {
  return { type: actions.replaceResultData, data }
}

export function replacePage (page: number) {
  return { type: actions.replacePage, page }
}

export function replaceLimit (limit: number) {
  return { type: actions.replaceLimit, limit }
}

export function replaceSearch (search: string) {
  return { type: actions.replaceSearch, search }
}

export function replaceFilter (startAt: string, endAt: string) {
  return { type: actions.replaceFilter, startAt, endAt }
}

export default function reducers (state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.replaceResult: {
      return produce(state, draft => {
        draft.result = action.result
        const actions: ActionName[] = ['print', 'rollback', 'delete']
        draft.result.data = palletService.tableHorizontalData(action.result.data, actions)
      })
    }
    case actions.replaceResultData:
      return produce(state, draft => {
        draft.result.data = action.data
      })
    case actions.replacePage:
      return produce(state, draft => {
        draft.page = action.page
      })
    case actions.replaceLimit:
      return produce(state, draft => {
        draft.limit = action.limit
      })
    case actions.replaceSearch:
      return produce(state, draft => {
        draft.search = action.search
      })
    case actions.replaceFilter:
      return produce(state, draft => {
        draft.startAt = action.startAt
        draft.endAt = action.endAt
      })
    default:
      return state
  }
}
